import React from 'react'
import { useRoutes } from 'react-router-dom'
import 'primeicons/primeicons.css'
import 'assets/css/App.css'
import portalRoutes from 'app/routes/routes'
import { selectorMenuDic } from 'app/core/slices/user/menu.slice'
import { getAppMode } from 'app/shared/utils/comUtil'
import _ from 'lodash'
import { useAppSelector } from 'app/core/hooks'
function App() {
    const menuDic = useAppSelector(selectorMenuDic)

    /**
     * 서비스 중단 등으로 메인에서 진입을 막을 때,
     * 건너뛰고 임의 진입하는 경우를 막는 용도로 사용 예정
     */
    const [serviceEnabled, setServiceEnabled] = React.useState(true)

    const routing = React.useMemo(() => {
        return portalRoutes(serviceEnabled || getAppMode() === 'local', menuDic)
    }, [window.location.pathname, menuDic, serviceEnabled])

    return useRoutes(routing)
}

export default App
